var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"faqs"},[_c('h2',[_vm._v(_vm._s(_vm.$t('faqs.headerTitle')))]),_c('div',{staticClass:"faq-items"},_vm._l((_setup.faqs),function(faq,index){return _c('div',{key:index,staticClass:"faq-item"},[_c('h3',[_vm._v(_vm._s(faq.title))]),_c('h5',{domProps:{"innerHTML":_vm._s(faq.description)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }